import { getItemVariant } from '@/common/analytics/gtm/shared/analyticsEventsComposers';
import { EventMessage, EventItem } from '@/common/analytics/gtm/types';
import { ArtworkFormatId } from '@/common/types/Artwork/Artwork.type';

export const mapMessageToEventItem = (eventMessage: EventMessage): EventItem => {
  const {
    message,
    metadata: {
      itemListName,
      listingFunction,
      listingType,
      gaPageName,
      listingSortMethod,
      optimizedFeedId,
      searchCategory,
    },
  } = eventMessage;

  return {
    index: message.index + 1,
    item_id: message.externalId.toString(),
    item_variant: getItemVariant(message.internalId, ArtworkFormatId.MEDIUM, 0, 0),
    item_list_id: `PT:${gaPageName}|LT:${listingType}|LF:${listingFunction}`,
    item_list_name: itemListName,
    ...(listingSortMethod && { listing_sort_method: listingSortMethod }),
    ...(optimizedFeedId && { optimized_feed_id: optimizedFeedId }),
    ...(searchCategory && { search_category: searchCategory }),
  };
};

/**
 * name: product name
 * id: EXTERNAL product id
 * dimension35: INTERNAL product id
 */
interface Product {
  name: string;
  id: string;
  dimension35: string;
  position: number;
}

/**
 * example:
 *
 * list: 'PT:product|LT:masonry|LF:popular'
 */
interface ProductImpression extends Product {
  list: string;
}

export const mapMessageToProduct = (eventMessage: EventMessage): Product => {
  const { message } = eventMessage;

  return {
    name: message.name || 'null',
    id: message.externalId.toString(),
    dimension35: message.internalId.toString(),
    position: message.index + 1,
  };
};

export const mapMessageToProductImpression = (eventMessage: EventMessage): ProductImpression => {
  const {
    metadata: { listingFunction, listingType, gaPageName },
  } = eventMessage;

  return {
    ...mapMessageToProduct(eventMessage),
    list: `PT:${gaPageName}|LT:${listingType}|LF:${listingFunction}`,
  };
};
